import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => {
	return {
		parent: {
			overflowX          : "hidden",
			overflowY          : "auto",
			display            : "flex",
			height             : theme?.other.isMobile ? "calc(100%  - 66px)" : "100%",
			flexDirection      : "column",
			justifyContent     : "flex-start",
			overscrollBehavior : "contain",
			// paddingTop     : props?.isStreamer ? "65px" : "0px",

			"&.followerChatParent": {
				...( !theme.other.isMobile && { height: "100%" } ),
				paddingTop: 0
			}

		},
		nameContainer: {
			margin       : "0 10px",
			flex         : 1,
			padding      : "7px",
			background   : "rgba(0,0,0,0.1)",
			borderRadius : "5px"
		},
		topContainer: {
			display    : "flex",
			marginLeft : "15px",
			width      : "fit-content",
			fontSize   : "12px",
			alignItems : "flex-end"
		},
		avatar: {
			height       : "30px",
			width        : "30px",
			objectFit    : "cover",
			borderRadius : "50%"
		},
		specialComment: {
			borderRadius : "20px",
			margin       : "5px 10px",
			width        : "fit-content",
			padding      : "5px 10px",
			background   : "rgb(0,0,0,0.1)",
			display      : theme.other.isApple ? "-webkit-box" : "flex"
		},
		commentContainer: {
			padding       : "1rem 1rem 1rem 0",
			display       : "flex",
			flex          : 1,
			flexDirection : "column",
			overflow      : "auto",
			overflowX     : "hidden",
			position      : "absolute",
			width         : "100%",
			height        : "100%"
		},
		liveAndFanRank: {
			// height           : "calc(100% - 103px)",
		},
		liveAndNoFanRank: {
			height: "calc(100% - 53px)"
		},
		notLiveAndFanRank: {
			height: "calc(100% - 48px)"
		},
		svgIcon: {
			...theme.other.svgIcons.size30,
			marginBottom: "0.5rem"
		},
		emptyStateContainer: {
			position  : "absolute",
			top       : "50%",
			transform : "translateY(-50%)",
			textAlign : "center",
			width     : "100%"
		},
		popUpIcon: {
			...theme.other.svgIcons.size20,
			marginRight: "1rem"
		},
		popOverStyle: {
			padding   : "1rem 0",
			boxShadow : "0 0 6px 0 rgb(0 0 0 / 16%)"
		},

		stickerContainer: {
			height : "150px",
			width  : "150px"
		},
		donationAmount: {
			padding         : "2px 8px 2px 8px",
			display         : "flex",
			alignItems      : "center",
			borderRadius    : "4px",
			backgroundColor : "#727272",
			color           : "#ffff",
			fontSize        : "14px",
			fontWeight      : "500",
			lineHeight      : "1.38"
		},
		donationSpan: {
			marginLeft: "3px"
		},
		commentHeader: {
			display        : "flex",
			flexDirection  : "row",
			justifyContent : "space-between",
			alignItems     : "center"
		},

		chatPopOut: {
			display        : "flex",
			width          : "100%",
			position       : "absolute",
			zIndex         : 5,
			top            : "50px",
			padding        : "10px",
			justifyContent : "flex-end"

		},
		popoutIcon: {
			cursor: "pointer"
		},

		/* this is for chat Tip */
		chatTipTopContainer: {
			display         : theme.other.isApple ? "-webkit-box" : "flex",
			marginBottom    : "1rem",
			width           : "100%",
			fontSize        : "1.2rem",
			alignItems      : "flex-start",
			backgroundColor : theme.other.colors.input.primary,
			// background   : theme.other.darkMode ? theme.other.paletteNew.darkModeInclinedBlack2 : theme.other.paletteNew.secondaryLightGrey,
			padding         : "1.5rem 1rem"
		},
		chatTipText: {
			paddingTop : "0.5rem",
			fontWeight : 500,
			fontSize   : "1.3rem",
			width      : "100%",
			// color      : "rgba(0, 0, 0, 0.85)"
			color      : theme.other.colors.text.primary

		},
		chatTipButton: {
			padding         : "0.3rem 1.5rem !important",
			boxShadow       : "none !important",
			backgroundImage : "linear-gradient(to top, #439aff 11%, #126bd5 92%) !important",
			textTransform   : "none !important",
			fontWeight      : "500 !important",
			fontSize        : "1.2rem !important",
			color           : "white !important",
			borderRadius    : "0.5rem !important"
		},
		pollChatTipContainer: {
			padding         : "1rem",
			backgroundColor : theme.other.darkMode ? theme.other.paletteNew.darkModeInclinedBlack2 : theme.other.paletteNew.secondaryLightGrey,
			display         : "flex",
			marginBottom    : "1rem"
		},
		pollsIconWrapper: {
			height: "100%"
		},
		pollsIcon: {
			width       : "20px",
			height      : "20px",
			marginRight : "5px"
		},
		pollsTextContainer: {
			display       : "flex",
			flexDirection : "column",
			fontSize      : "1.3rem"
		},
		chatTip: {
			height : "3rem",
			width  : "3rem"

		},
		bulbContainer: {
			height     : "100%",
			display    : "flex",
			alignItems : "center"
		},
		tipText: {
			width: "100%"
		}
	};
} );
